'use client';

import React from 'react';
import { useIntl } from 'react-intl';

import { Typography } from '@packages/shared';
import { legalHintsMessages } from './messages';

export interface LegalHintsProps extends Pick<React.HTMLAttributes<HTMLDivElement>, 'style'> {
  /**
   * defines the surcharge for a selected payment pause
   */
  paymentPauseValuta: number | null;
}

const typographyVariant = 'body3';

/**
 * legal hints atom
 *
 * atom to display the legal hints
 *
 * config installmentCalculator.useLegalHint defines whether it should used or not
 *
 * */
export const LegalHints = ({ paymentPauseValuta }: LegalHintsProps) => {
  const { formatMessage } = useIntl();

  return (
    <div className="grid grid-cols-12 gap-x-4 gap-y-2 sm:gap-x-6 md:gap-x-4">
      {paymentPauseValuta !== null && paymentPauseValuta > 0 && (
        <>
          <div className="col-span-1 flex items-center">
            <Typography variant={typographyVariant}>*</Typography>
          </div>
          <div className="col-span-11">
            <Typography variant={typographyVariant}>
              {formatMessage(legalHintsMessages.PaymentPauseSurcharge, { paymentPauseValuta })}
            </Typography>
          </div>
        </>
      )}
      <div className="col-span-1 flex items-center">
        <Typography variant={typographyVariant}>**</Typography>
      </div>
      <div className="col-span-11">
        <Typography variant={typographyVariant}>
          {formatMessage(legalHintsMessages.BasketHint)}
        </Typography>
      </div>
    </div>
  );
};
